
















import Vue from "vue";
import iwInputRadioGroup from "@/encoding/components/buildingBlocks/InputRadioGroup.vue";

export default Vue.extend({
    components: {
        iwInputRadioGroup: iwInputRadioGroup,
    },
    data: function () {
        return {
            pathInStore: "property.constructionPermit.isBreachingUrbanPlanningRegulation",
            radios: [
                {"value": true, "label": "yes"},
                {"value": false, "label": "no"},
                {"value": "not_specified", "label": "not_specified"}
            ]

        };
    },
    computed: {
        isBreaching: function(): string|boolean {
            const value = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if (value === true) {
                return true;
            }
            if (value === false) {
                return false;
            }
            return "not_specified";
        },
    },
    methods: {
        updateValue: function(selectedValue: string|boolean): void {
            if (selectedValue == "not_specified") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
            if (selectedValue === true) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": true});
            }
            if (selectedValue === false) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": false});
            }
        }
    }
});

